document.addEventListener('DOMContentLoaded', function() {
    const counters = document.querySelectorAll('.counter');

    if (!counters) {
        return;
    }

    counters.forEach((counter) => {
        const counterDigits = counter.querySelectorAll('.counter__digit');
        const totalDigits = counterDigits.length;
        const targetCount = counter.getAttribute('data-count') || "000000";
        const animationDuration = 3000; // Duration in milliseconds

        function animateDigit(digitElement, targetValue, delay) {
            let currentValue = 0;
            const increment = targetValue / (animationDuration / 100);

            function updateDigit() {
                if (currentValue < targetValue) {
                    currentValue += increment;
                    digitElement.textContent = Math.floor(currentValue);
                    requestAnimationFrame(updateDigit);
                } else {
                    digitElement.textContent = targetValue;
                }
            }

            setTimeout(updateDigit, delay);
        }

        function startAnimation() {
            counterDigits.forEach((digit, index) => {
                if (index >= totalDigits - 6) {
                    const delay = (totalDigits - index - 1) * 100; // Delay for each digit
                    const targetValue = parseInt(targetCount.charAt(index), 10);

                    if (targetValue > 0) {
                        animateDigit(digit, targetValue, delay);
                    }
                }
            });
        }

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.intersectionRatio >= 1) {
                    startAnimation();
                    observer.unobserve(counter);
                }
            });
            for (const { isIntersecting, target } of entries) {
                if (isIntersecting) {
                    startAnimation();
                    observer.unobserve(target);
                }
            }
        }, { root: null, rootMargin: '-100px 0px', threshold: [1.0] });

        observer.observe(counter);
    });
});